import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { UpdateDataFile } from './update-data-file';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IUpdateDataFileStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IUpdateDataFileConnectProps = IUpdateDataFileStateProps & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IUpdateDataFileStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config
  };
}

export const UpdateDataFileContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(UpdateDataFile);
